import axios from "axios";
import toastBeBounce from "../components/toastBeBounce";
import qs from "qs";
//import getCookie from "./cookie";
import { getDomain } from "./index";

const domain = '.saas.quanmai.cloud';

//开发环境和生产环境
const runVersion = process.env.NODE_ENV;
if (runVersion === "development") {       //开发环境
  axios.defaults.baseURL = "";
} else if (runVersion === "production") {  //生产环境
  axios.defaults.baseURL = "";
}

//请求超时时间
axios.defaults.timeout = 10000;

//post请求头
axios.defaults.headers.post["Content-Type"] = "application/x-www-form-urlencoded;charset=UTF-8";
//配置请求拦截器
axios.interceptors.request.use ((config) => {
  //统一加token
  if (sessionStorage.token) {
    config.headers["Authorization"] = `${sessionStorage.token}`;
  }
  return config;
}, (error) => {
  return Promise.error (error);
});

//配置响应拦截器
axios.interceptors.response.use ((response) => {
  //状态过滤
  if (response.status === 200) {
    return Promise.resolve (response.data);
  } else {
    return Promise.reject (response.data);
  }
}, (error) => {
  if (error.response) {
    switch (error.response.status) {
      case 401:
        //getCookie (error.response.config.url, error.response.config.data, error.response.config.method);
        let appid = getDomain();
        sessionStorage.setItem("isToken",true);
        window.location.href =  `http://${appid}${domain}?Callback=${encodeURI(window.location.href)}&source=3`;
        break;
      default:
        toastBeBounce (5000);
    }
  } else {
    toastBeBounce (5000);
  }
});

//请求方法
export default function ajax (url = "", params = {}, token = false, type = "GET", header) {
  const user_id = sessionStorage.getItem ("user_id");
  const company_id = sessionStorage.getItem ("company_id");
  const p = { ...params };
  if (`${params.sid}` === "1" && user_id && !p.user_id) {
    p.user_id = user_id;
  }
  if (`${params.sid}` === "1" && company_id && !p.company_id) {
    p.company_id = company_id;
  }
  return new Promise ((resolve, reject) => {
    let promis;
    //判断请求类型
    if (type.toUpperCase () === "GET") {
      promis = axios ({
        url,
        params: p,
        token
      });
    } else if (type.toUpperCase () === "POST") {
      promis = axios ({
        method: "post",
        url,
        data: qs.stringify (params),
        token,
        headers: header?header:{
          "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8"
        }
      });
    } else if (type.toUpperCase () === "PUT") {
      promis = axios ({
        method: "put",
        url,
        data: qs.stringify (params),
        token,
        headers: {
          "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8"
        }
      });
    }
    //处理结果
    promis.then ((response) => {
      resolve (response);
    }).catch ((error) => {
      reject (error);
    });
  });
}
